document.addEventListener("DOMContentLoaded", () => {
  // Hide reputon after 5s
  const style = document.createElement('style');
  style.textContent = `
    @keyframes reputonFadeOut {
      0% { opacity: 1; visibility: visible; }
      80% { opacity: 1; visibility: visible; }
      100% { opacity: 0; visibility: hidden; }
    }

    .reputon-google-reviews-widget[data-sticky="true"] {
      animation: reputonFadeOut 5s ease-in-out forwards;
    }
    
    body .reputon-google-reviews-widget .reputon-reviews-holder {
      transition: bottom 0.25s ease !important;
    }
    
    body.chat-moved-up .reputon-google-reviews-widget .reputon-reviews-holder {
      bottom: 60px !important;
    }
  `;
  document.head.appendChild(style);

  const stickyMobile = document.querySelector("#mobile-sticky-atc");
  const stickyDesktop = document.querySelector("sticky-atc-panel");

  const interval = setInterval(() => {
    const reputon = document.querySelector(".reputon-google-reviews-widget .dmEjTW");
    const mainMenu = document.querySelector("main-menu");
    const cartDrawer =
      document.querySelector("#cart-drawer") || document.querySelector("cart-drawer");
    const klaviyoPopup = document.querySelector(".klaviyo-form, [data-testid*='klaviyo']");

    if ((stickyMobile || stickyDesktop) && reputon) {
      clearInterval(interval);

      reputon.style.transition =
        "bottom 0.4s ease, transform 0.4s ease, opacity 0.3s ease, z-index 0.3s ease";

      const updateReputonPosition = () => {
        const isFixed = getComputedStyle(reputon).position === "fixed";

        // ✅ Sticky móvil visible si display ≠ none
        const stickyMobileVisible =
          stickyMobile && window.getComputedStyle(stickyMobile).display !== "none";

        // ✅ Sticky de escritorio visible si NO tiene la clase --out
        const stickyDesktopVisible =
          stickyDesktop &&
          !stickyDesktop.classList.contains("sticky-atc-panel--out");

        // 🚫 Ocultar si menú, drawer o popup están activos
        const menuOpen =
          mainMenu &&
          (mainMenu.querySelector("details[open]") || mainMenu.querySelector(".is-open"));
        const drawerOpen =
          cartDrawer &&
          (cartDrawer.getAttribute("hidden") === "false" ||
            cartDrawer.hasAttribute("open") ||
            cartDrawer.classList.contains("is-open"));
        const popupVisible =
          klaviyoPopup &&
          (window.getComputedStyle(klaviyoPopup).display !== "none" ||
            klaviyoPopup.classList.contains("klaviyo-form-visible"));

        if (menuOpen || drawerOpen || popupVisible) {
          reputon.style.opacity = "0";
          reputon.style.pointerEvents = "none";
          reputon.style.zIndex = "0";
          return;
        } else {
          reputon.style.opacity = "1";
          reputon.style.pointerEvents = "auto";
          reputon.style.zIndex = "999";
        }

        // 🔹 Mover según sticky visible
        if (stickyDesktopVisible) {
          // Sticky panel de escritorio
          reputon.style.transform = "translateY(-110px)";
        } else if (stickyMobileVisible) {
          // Sticky de móvil
          reputon.style.transform = "translateY(-53px)";
        } else {
          // Ninguno visible
          reputon.style.transform = "translateY(0)";
        }
      };

      // Coalesce todas las actualizaciones a una por frame para evitar
      // lecturas de layout (getComputedStyle) en cada evento o mutación.
      let ticking = false;
      const scheduleUpdate = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          ticking = false;
          updateReputonPosition();
        });
      };

      // Observadores para detectar cambios dinámicos
      [stickyMobile, stickyDesktop, mainMenu, cartDrawer].forEach((el) => {
        if (el) {
          new MutationObserver(scheduleUpdate).observe(el, {
            attributes: true,
            subtree: true,
            attributeFilter: ["style", "class", "aria-hidden", "open", "hidden"],
          });
        }
      });

      // Eventos de respaldo
      window.addEventListener("scroll", scheduleUpdate, { passive: true });
      window.addEventListener("resize", scheduleUpdate, { passive: true });
      document.addEventListener("click", () => setTimeout(scheduleUpdate, 100));

      // Primera ejecución
      updateReputonPosition();
    }
  }, 400);
});
